export default "/img/BM.c3f84b9c58c472b81c0e3c458d14275c.png";